<template>
  <el-dialog
    :visible.sync="innerVisible"
    :title="title || $t('CargoMsg.Cargo_ChooseEdiTemplate')"
    :close-on-click-modal="false"
    :destroy-on-close="true"
    top="5vh"
    width="500px"
    class="grid-view"
  >
    <div style="margin-bottom: 10px">
      <el-button type="primary" no="1" @click="onSelect">{{ $t('CargoMsg.Cargo_Select') }}</el-button>
    </div>
    <div class="main-content">
      <div class="section grid-wrapper">
        <cargo-ag-grid
          :grid-params.sync="gridParams"
          :grid-options="gridOptions"
          :column-defs="columnDefs"
          :row-data="rowData"
          :show-side-bar="false"
        />
      </div>
    </div>
  </el-dialog>
</template>

<script>
import { getEDITemplate } from '@/api/sysManage/baseConfig/ediTemplate'
import ColumnUtils from '@/utils/ColumnUtils'
import { TYPE_NAMES } from '@/utils/class/AdvanceSelect'
export default {
  name: 'EdiPopup',
  props: {
    visible: { type: Boolean, required: true },
    title: { type: String, default: '' },
    templateType: { type: Number, default: null }
  },
  data() {
    return {
      selectedRow: null,
      gridParams: {},
      rowData: [],
      gridApi: null,
      gridOptions: {
        rowSelection: 'single',
        suppressCellSelection: true,
        context: {
          componentParent: this
        },
        onRowDoubleClicked: this.onRowDoubleClicked,
        onRowClicked: this.onGridRowClickedEvent
      },
      columnDefs: [
        {
          headerName: this.$t('CargoMsg.Cargo_Note'), field: 'templateDescribe', colId: 'templateDescribe', width: 200
        },
        {
          headerName: this.$t('CargoMsg.Cargo_Parter'), field: 'parnterId', colId: 'parnterId', width: 200,
          cellRenderer: (params) => {
            return ColumnUtils.companyShortNameLabelFun(params.value)
          }
        },
        {
          headerName: this.$t('CargoMsg.Cargo_Remarks'), field: 'remarks', colId: 'remarks', width: 200
        }
      ]
    }
  },
  computed: {
    innerVisible: {
      get() {
        return this.visible
      },
      set(val) {
        if (!val) {
          this.$emit('close', val)
        } else {
          this.$emit('open', val)
        }
      }
    }
  },
  watch: {
  },
  methods: {
    init() {
      getEDITemplate({ templateType: this.templateType }).then(result => {
        this.rowData = result.data
      })
    },
    onSelect() {
      if (!this.selectedRow) {
        this.$message.warning(this.$t('CargoMsg.Cargo_PleaseSelectARecord'))
      }
      this.$emit('ok', this.selectedRow)
    },
    onRowDoubleClicked(e) {
      const data = e.data
      this.selectedRow = data
      this.onSelect()
    },
    onGridRowClickedEvent(e) {
      const data = e.data
      this.selectedRow = data
    }
  }
}
</script>

<style scoped>

</style>
